import axiosClient from 'lib/axiosClient';
import { useSnackbar } from 'notistack';
import { useState } from 'react';

const useSetChangeBranchPostFix = () => {
  const { enqueueSnackbar } = useSnackbar();
  const [loading, setLoading] = useState(false);

  const setBranchPostFix = (
    guid,
    postFixValue,
    handleClose,
    // eslint-disable-next-line max-params
  ) => {
    setLoading(true);
    axiosClient
      .put(`Product/Branch/ChangePostFix`, {
        guid,
        postFix: postFixValue,
      })
      .then(res => {
        if (res.status === 200) {
          enqueueSnackbar(res?.data?.message, { variant: 'success' });
          handleClose();
        } else {
          enqueueSnackbar(res?.message, { variant: 'error' });
        }
      })
      .catch(err => {
        console.log(err);
        enqueueSnackbar(err?.message, { variant: 'error' });
      })
      .finally(() => setLoading(false));
  };
  return [setBranchPostFix, loading];
};

export default useSetChangeBranchPostFix;
